import {
  injectRequiredWithSelf,
  checkValuesAlreadyProvided,
  CreateInjectionKeysRecord,
  type InjectionKeysRecord,
  type InjectionValuesRecord,
} from "@mcwd/util-vue";
import { provide } from "vue";
import { useBlindSubmit } from './use-blind-submit.js';
import type { LinkDownloadType } from '../../tracking/LinkDownloadType.js';
import { sendDownloadEvent } from '../../tracking/send-download-event.js';
import type { DocumentResource } from '../../widgetDataTs.js';

type DownloadResourceArgs = {
  asset: DocumentResource;
  ctaType: LinkDownloadType;
  ctaText: string;
  allowBlindSubmit?: boolean
}

type UseFormAssetDownloadInjectionValues = InjectionValuesRecord<{
  downloadResourceTracking: (args: DownloadResourceArgs) => void
}>;

type UseFormAssetDownloadInjectionKeys =
  InjectionKeysRecord<UseFormAssetDownloadInjectionValues>;

const UseFormAssetDownloadInjectionKeys = CreateInjectionKeysRecord<UseFormAssetDownloadInjectionKeys>({
  downloadResourceTracking: "downloadResourceTracking"
});

export function initFormAssetDownloads() {
  if (checkValuesAlreadyProvided(UseFormAssetDownloadInjectionKeys)) {
    return;
  }
  const { submitBlindFormIfEnabled } = useBlindSubmit();

  const downloadResourceTracking = ({ asset, ctaType, ctaText, allowBlindSubmit = true }: DownloadResourceArgs) => {
    sendDownloadEvent({ asset, ctaType, ctaText });
    if (allowBlindSubmit) {
      submitBlindFormIfEnabled();
    }
  };

  provide(UseFormAssetDownloadInjectionKeys.downloadResourceTracking,
    downloadResourceTracking
  );
}

export function useFormAssetDownload() {
  const downloadResourceTracking = injectRequiredWithSelf(
    UseFormAssetDownloadInjectionKeys.downloadResourceTracking
  );

  return { downloadResourceTracking };
}
